/**
 * This file is part of "Zona franca"
 * Copyright (c) 2022
 * Zona franca
 * All rights reserved
 *
 * @author Turiano Romero <https://bitbucket.org/rome9603/ | tromero@technisupport.com>
 * @version 2.0
 */

import { customsClearanceTypes } from "redux/types";

const initialState = {
  idShowCustoms: null
};

export const customsClearanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case customsClearanceTypes.idShowCustoms:
      return {
        ...state,
        idShowCustoms: action.payload
      };
    default:
      return state;
  }
};
